export default __webpack_public_path__ + "static/media/eb-ultra-blk-banner-2.9f0319dd.jpg";